import { CHANGE_TYPE, DEFAULT_SELECTED_OPTION } from './gitDiffConstants';


function pathSorterFunction(a, b) {
	const folderPathCompare = a.folderPath ? a.folderPath.toLowerCase().localeCompare(b.folderPath && b.folderPath.toLowerCase()) : -1
	if (folderPathCompare === 0) {
		return a.name ? a.name.toLowerCase().localeCompare(b.name && b.name.toLowerCase()) : -1;
	}
	return folderPathCompare;
}

function nameSorterFunction(a, b) {
	return a.name ? a.name.toLowerCase().localeCompare(b.name && b.name.toLowerCase()) : -1;
}

function getPath(path, fileOrFolder) {
	return path + '/' + fileOrFolder.name;
}

function existsInLocalFolder(file, localFolder) {
	return localFolder.files.some(f => f.filePath === file.filePath);
}

function addSubfolder(localFolder, remoteFolder, merged, selected, defaultActions) {
	const localFiles = new Set();
	if (localFolder.files) {
		for (const file of localFolder.files) {
			const remoteFile = remoteFolder && remoteFolder.files && remoteFolder.files.find((f) => f.filePath === file.filePath);
			let movedFile;

			if (remoteFile != null && !selected[remoteFile.filePath]) {
				continue;
			}
			if (!remoteFile) {
				movedFile = remoteFolder && remoteFolder.files && remoteFolder.files.find(f => {
					return f.name === file.name && f.checksum === file.checksum && !existsInLocalFolder(f, localFolder);
				});
			}

			let type = CHANGE_TYPE.NO_CHANGE;
			if (remoteFile == null) {
				

				if (movedFile) {
					type = CHANGE_TYPE.MOVED;
					localFiles.add(movedFile.filePath);
				} else {
					type = CHANGE_TYPE.DELETED;
				}

			} else if(remoteFile != null && remoteFile.checksum != file.checksum) {
				type = CHANGE_TYPE.CHANGED;
			}
			if (type !== CHANGE_TYPE.NO_CHANGE) {
				merged.files.push({
					...file,
					content: null,
					type,
					selectedOption: defaultActions && defaultActions[type] || DEFAULT_SELECTED_OPTION[type],
					newFolderPath: movedFile != null ? movedFile.folderPath : undefined,
					newBreadcrumb: movedFile != null ? movedFile.breadcrumb : undefined
				});
			}
			localFiles.add(file.filePath);
		}
	}
	if (remoteFolder && remoteFolder.files) {
		for (const file of remoteFolder.files) {
			if (!localFiles.has(file.filePath) && selected[file.filePath]) {
				merged.files.push({
					...file,
					content: null,
					type: CHANGE_TYPE.NEW,
					selectedOption: defaultActions && defaultActions[CHANGE_TYPE.NEW] || DEFAULT_SELECTED_OPTION[CHANGE_TYPE.NEW]
				});
			}
		}
	}
}

function addRemoteSubfolder(remoteFolder, merged, selected, defaultActions) { 
	if(remoteFolder.files) {
		for (const file of remoteFolder.files) {
			if (selected && selected[file.filePath]) {
				merged.files.push({
					...file,
					content: null,
					type: CHANGE_TYPE.NEW,
					selectedOption: defaultActions && defaultActions[CHANGE_TYPE.NEW] || DEFAULT_SELECTED_OPTION[CHANGE_TYPE.NEW]
				});
			}
		}
	}
}


export function gitDiffFolders(localFolders, remoteFolders, selected, defaultActions) {

	const merged = [];

	for (const folder of localFolders) {
		const remoteFolder = remoteFolders && remoteFolders.find((f) => f.name === folder.name);
		const mergedFolder = {
			name: folder.name,
			files: []
		};
		const folderDefaultActions = defaultActions && defaultActions[folder.name];
		
		addSubfolder(folder, remoteFolder, mergedFolder, selected, folderDefaultActions);
		if (mergedFolder.files.length > 0) {
			mergedFolder.files.sort(pathSorterFunction);
			merged.push(mergedFolder);
		}
	}
	if (remoteFolders) {
		for (const folder of remoteFolders) {
			const localFolder = localFolders.find((f)=>f.name === folder.name);
			if (!localFolder) {
				const mergedFolder = {
					name: folder.name,
					files: []
				};
				const folderDefaultActions = defaultActions && defaultActions[folder.name];

				addRemoteSubfolder(folder, mergedFolder, selected, folderDefaultActions);
				if (mergedFolder.files.length > 0) {
					merged.push(mergedFolder);
				}
			}
		}
	}

	merged.sort(nameSorterFunction);

	return merged;
}

export function findFileInFolder(folders, startFolderName, file) {
	const folder = folders && folders.find((f) => f.name === startFolderName);
	return folder && folder.files && folder.files.find((f) => f.filePath === file.filePath);
}



function getNextContext(context, folder) {
	return {
		...context,
		folderPath: context.folderPath + '/' + folder.name,
		breadcrumb: context.breadcrumb.concat(folder.name)
	};
}


function addFolderToList(list, folder, context) {
	if (folder.files) {
		for (const file of folder.files) {
			const fileData = {
				...file,
				breadcrumb: context.breadcrumb,
				folderPath: context.folderPath,
				filePath: getPath(context.folderPath, file),
			};
			if (context.callback) {
				context.callback(fileData, file);
			}
			list.push(fileData);
		}
	}
	if (folder.folders) {
		for (const subFolder of folder.folders) {
			addFolderToList(list, subFolder, getNextContext(context, subFolder));
		}
	}
}

export function convertToList(tree, callback) {
	const list = [];
	if (!tree.folders) {
		return list;
	}

	for (const rootFolder of tree.folders) {

		const context = {
			callback,
			folderPath: '/' + rootFolder.name,
			breadcrumb: [rootFolder.name]
		};
		
		const folderData = {
			name: rootFolder.name,
			files: []
		}
		addFolderToList(folderData.files, rootFolder, context);
		if (folderData.files.length  > 0) {
			folderData.files.sort(pathSorterFunction);
			list.push(folderData);
		} 
	}

	list.sort(nameSorterFunction);
	return list;
}

function getOrCreateSubFolder(folder, breadcrumb) {
	if (breadcrumb.length === 0) {
		if (!folder.files) {
			folder.files = [];
		}
		return folder;
	} else {
		let subFolder = folder.folders && folder.folders.find((f) => f.name === breadcrumb[0]);
		if (!subFolder) {
			subFolder = { name: breadcrumb[0] };
			folder.folders = folder.folders ? folder.folders.concat(subFolder) : [subFolder];
		}
		return getOrCreateSubFolder(subFolder, breadcrumb.slice(1));
	}
}

export function convertToTree(list) {
	const allRootFolder = [];
	for (const folder of list) {
		const rootFolder = {
			name: folder.name
		};
		
		for (const file of folder.files) {
			const breadcrumb = file.type === CHANGE_TYPE.MOVED && file.selectedOption === 'REMOTE' ? file.newBreadcrumb : file.breadcrumb;
			const folder = getOrCreateSubFolder(rootFolder, breadcrumb.slice(1));
			folder.files.push(
				{
					name: file.name,
					action: file.selectedOption,
					content: file.selectedOption === 'MERGE_LOCAL' || file.selectedOption === 'MERGE_REMOTE' ? file.content : undefined
				}
			);
			if (file.type === CHANGE_TYPE.MOVED && file.selectedOption === 'REMOTE') {
				const deleteBreadcrumb =  file.breadcrumb;
				const deleteFolder = getOrCreateSubFolder(rootFolder, deleteBreadcrumb.slice(1));
				deleteFolder.files.push(
					{
						name: file.name,
						action: 'DELETE'
					}
				);
			}
		}

		allRootFolder.push(rootFolder);
	}
	return allRootFolder;
}